// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3zS5D","disabled":"FileBtn_disabled__1gyVb","warn":"FileBtn_warn__34pIM","fade":"FileBtn_fade__1s5eU"};